import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import axios from "axios";
import interceptorsSetup from "./helpers/interceptors";

import SmoothReflow from "@/components/smoothReflow/SmoothReflow";
Vue.component("SmoothReflow", SmoothReflow);

interceptorsSetup();

window.axios = axios;
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
